<template>
  <div :class="classModifiers">
    <div @click.stop="onClickNumber">
      <span class="market-shares-ownership__number">{{ numberDisplay }}</span>
      <span class="market-shares-ownership__mode">{{ mode }}</span>
    </div>
  </div>
</template>

<script src="./market-shares-ownership.js"></script>
<style src="./market-shares-ownership.scss" lang="scss"></style>
